import api from "./api";
import colors from "./colors";
import embed from "./embed";
import geojson from "./geojson";
import results from "./results";
import ux from "./ux";
import congressControl from "./congressControl";
import tooltip from "./tooltip";

export default {
  api,
  colors,
  embed,
  geojson,
  results,
  ux,
  congressControl,
  tooltip,
};
